import React from 'react';
import { BigNumber } from 'ethers';

export type WalletAssetsContextValue = {
  balance?: BigNumber;
  readBalance: () => void;
  honeyBalance?: BigNumber;
  readHoneyBalance: () => void;
  oldHoneyBalance?: BigNumber;
  readOldHoneyBalance: () => void;
};

// @ts-ignore
const WalletAssetsContext = React.createContext<WalletAssetsContextValue>();

WalletAssetsContext.displayName = 'WalletAssetsContext';

export default WalletAssetsContext;
